import React from 'react';
import './Clientes-Modal.css';
import Video from './assets/Convento/Video.mp4';
const Convento = () => {
    return (
        <div  className="container">
          <h2> ✅ Proyecto: Convento Santa Clara🌞✨</h2>

<p>

      <video controls>
                <source src={Video} type="video/mp4" />
                Tu navegador no soporta la reproducción de video.
              </video>
<span className="highlight">Energía solar al servicio de la vida contemplativa: eficiencia, ahorro y compromiso con el cuidado de la creación.</span>


<br/><br/> En el Convento Santa Clara instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 12.78 kWp, conformado por 18 paneles solares de alta eficiencia y un inversor multicadena de 15 kW, una tecnología confiable que garantiza estabilidad energética y un óptimo aprovechamiento de la energía solar para las actividades diarias del convento.

<br/><br/>Gracias a esta solución, el sistema respalda de manera eficiente los consumos eléctricos del lugar —iluminación, cocina, equipos básicos y áreas comunes— reduciendo la dependencia de la red y optimizando los costos de operación.

<br/><br/>Los objetivos de este proyecto fueron:

<br/><br/>✔ Reducir los costos asociados al consumo eléctrico del convento
<br/>✔ Implementar una solución sostenible alineada con el compromiso ambiental de la comunidad religiosa
<br/>✔ Garantizar energía constante y segura para las actividades diarias y comunitarias

<br/><br/>Hoy, el Convento Santa Clara genera una parte importante de su energía limpia, logrando ahorros significativos en la factura eléctrica mensual y contribuyendo activamente a la reducción de la huella ambiental.

<br/><br/>Esta instalación convierte al convento en un ejemplo de responsabilidad energética y coherencia entre fe, sostenibilidad y cuidado del entorno.

<br/><br/>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:

<br/><br/>🔧 Soporte técnico y mantenimiento preventivo.
<br/>🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
<br/>🔧 Instalación estructural segura, diseñada para prolongar la vida útil del sistema y facilitar su mantenimiento.
<br/>🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
<br/>🔧 Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.

<br/><br/>Una decisión consciente que une sostenibilidad, ahorro y servicio comunitario.
</p>
        </div>
    );
}

export default Convento;
